import { mapState } from 'vuex'

const AutoRefresh = {
  watch: {
    filter() { if (this.fetch) this.fetch() }
  },
  computed: mapState(['filter'])
};
export default AutoRefresh;
